import React from "react";
import ReactLoading from "react-loading";

interface IProps {
}

export class Spinner extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    render() {
        return (
            <ReactLoading type={"spin"} color={"#007bff"} height={"40px"} width={"40px"} />
        );
    }
}

export default Spinner;